<div class="user-header">
    @if (mlife) {
        <div class="user-header__username ds-title-md-strong" [innerHtml]="mlife.userGreeting | trustAsHtml"></div>
        <div class="user-header__details ds-label-md">
            <span [innerHtml]="mlife.tierNumberText | trustAsHtml"></span>
            <span [innerHtml]="mlife.tierDescription | trustAsHtml"></span>
            <span (click)="processClick($event, item)" class="user-header__link">
                <span>{{ mlife.viewDetailsText }}</span>
                <vn-icon name="theme-right" size="12" class="user-header__arrow-icon" />
            </span>
        </div>
    }
</div>
